import { render, staticRenderFns } from "./Wysiwyg.vue?vue&type=template&id=0cf40510&scoped=true&"
import script from "./Wysiwyg.vue?vue&type=script&lang=ts&"
export * from "./Wysiwyg.vue?vue&type=script&lang=ts&"
import style0 from "./Wysiwyg.vue?vue&type=style&index=0&id=0cf40510&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf40510",
  null
  
)

export default component.exports